import '@babel/polyfill';
import Vue from 'vue';
import App from './App';
import './dxrj.sdk/js/axios';
import routerConfig from './main/assets/js/config/router-config';
import store from './dxrj.sdk/js/kit/storeKit';
import 'view-design/dist/styles/iview.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 引入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
// require styles 富文本编辑器对应的样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 注册富文本编辑器组件为全局组件
Vue.use(VueQuillEditor)
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载
// 引入 svg
import './main/assets/icons';
// 引入 通用 CSS
import './dxrj.sdk/styles/css/index.css';
// 粒子特效
import VueParticles from 'vue-particles';
// import currentDateTime from 'currentDateTime';
// import 'currentDateTime/lib/currentDateTime.css';
// element-ui-table-插件，内容列宽自适应
import AFTableColumn from 'af-table-column';

// import { initDingH5RemoteDebug } from "dingtalk-h5-remote-debug";
// initDingH5RemoteDebug();

// Vue.use(currentDateTime);
Vue.use(ElementUI);
Vue.use(VueParticles);
Vue.use(AFTableColumn);

const router = routerConfig();
export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
